import React from "react";
import { GridApi } from "ag-grid-community";
import { sum } from "./sum";
import { RowComputeParams } from "./types";
import { ProductCollectionGridView } from "components/product-collection/product-collection-views";
import { MetricsKind } from "helpers/metrics/types";

/**
 * Get aggregrated total units of the entire column. Loop through all row nodes and sum their values.
 */
export const getColumnTotalUnit = (
    mainGridApi: GridApi,
    gridViewRef: React.RefObject<ProductCollectionGridView>,
    colId: string
) => {
    const rows = [];
    mainGridApi.forEachNodeAfterFilter((node) => {
        // Only take leaf node (not group row)
        if (!node.group) {
            rows.push(node);
        }
    });

    const units = gridViewRef.current.getMetricValuesForRows(colId, MetricsKind.UNITS, rows);

    return sum(units);
};

export const UNITS = (params: RowComputeParams) => {
    const { metricKind, mainRowNodes, getterParams, gridViewRef } = params;
    const values = gridViewRef.current
        ?.getMetricValuesForRows(getterParams.column.getColId(), metricKind, mainRowNodes)
        .map((value) => {
            if (isNaN(value)) {
                return 0;
            }
            return value;
        });

    return sum(values);
};
